export class Name {
  prefix: string;
  firstName: string;
  middleName: string;
  lastName: string;
  suffix: string;

  constructor() {
    this.prefix = '';
    this.firstName = '';
    this.middleName = '';
    this.lastName = '';
    this.suffix = '';
  }
}
